import React, { useState } from 'react';
import { FiCamera, FiCheckSquare, FiUsers, FiZap } from 'react-icons/fi';
import MobileCameraModal from './MobileCameraModal';
import MobileTaskModal from './MobileTaskModal';
import { useGnomeContext } from '../../context/GnomeContext';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

const ActionButton = ({ icon: Icon, label, onClick, color = 'bg-charcoal-800', iconColor = 'text-charcoal-400' }) => (
    <button
        onClick={onClick}
        className="flex flex-col items-center justify-center p-6 bg-charcoal-800 rounded-2xl shadow-sm border border-charcoal-700 active:scale-95 transition-all hover:bg-charcoal-700 aspect-square"
    >
        <div className={`w-14 h-14 rounded-full ${color} flex items-center justify-center mb-3 shadow-inner ring-1 ring-white/5`}>
            <Icon size={24} className={iconColor} />
        </div>
        <span className="font-semibold text-charcoal-200 text-sm">{label}</span>
    </button>
);

const MobileQuickActions = () => {
    const { generateInsights } = useGnomeContext();
    const navigate = useNavigate();
    const [cameraOpen, setCameraOpen] = useState(false);
    const [taskModalOpen, setTaskModalOpen] = useState(false);

    const handleCheckIn = async () => {
        toast.promise(generateInsights(), {
            loading: 'Running check-in...',
            success: 'Check-in complete!',
            error: 'Check-in failed'
        });
    };

    return (
        <div className="flex flex-col min-h-full bg-black p-6 pt-12 pb-24">
            <h1 className="text-2xl font-bold text-white mb-2">Quick Actions</h1>
            <p className="text-charcoal-400 mb-8">What would you like to do?</p>

            <div className="grid grid-cols-2 gap-4">
                <ActionButton
                    icon={FiCamera}
                    label="Capture Asset"
                    onClick={() => setCameraOpen(true)}
                    color="bg-purple-900/30"
                    iconColor="text-purple-400"
                />

                <ActionButton
                    icon={FiZap}
                    label="Daily Check-in"
                    onClick={handleCheckIn}
                    color="bg-amber-900/30"
                    iconColor="text-amber-400"
                />

                <ActionButton
                    icon={FiCheckSquare}
                    label="Log Task"
                    onClick={() => setTaskModalOpen(true)}
                    color="bg-blue-900/30"
                    iconColor="text-blue-400"
                />


            </div>

            {/* Modals */}
            <MobileCameraModal isOpen={cameraOpen} onClose={() => setCameraOpen(false)} />
            <MobileTaskModal isOpen={taskModalOpen} onClose={() => setTaskModalOpen(false)} />
        </div>
    );
};

export default MobileQuickActions;
